import request from '@/utils/request'
import qs from 'qs'
/** ************************************************** 营销APP页面接口 ************************************************** */

/**
 * 根据 Id 获取模版模块内容
 */
export function getplates(data) {
    return request({
        url: '/v1/template/plates',
        method: 'get',
        params:data
    })
}



 /**
 * 根据 Id 获取模版模块内容
 * {
 *  id:"",
 *  plateId:"",
  * }
 */
export function savetemplate(data) {
    return request({
        url: '/v1/template',
        method: 'put',
        data
    })
}








/**
 * 文件上传
 * @param {data} data
 */
export function updataimg(data) {
    return request({
        url: '/v1/file/upload/file',
        method: 'post',
        data
    })
}

/**
 * App活动品牌列表
 */
// export function getapppage() {
//     return request({
//         url: '/v1/app_page',
//         method: 'get'
//     })
// }

export function getapppage() {
    return request({
        url: '/v1/app_brand/',
        method: 'GET'
    })
}




/**
 * 新增app活动
 * @param marketApppage: {
    "brand": "",
    "createBy": "",
    "createTime": "",
    "data": "",
    "delFlag": "",
    "id": 0,
    "lastUpdateBy": "",
    "lastUpdateTime": "",
    "link": "",
    "sort": "",
    "standby5": "",
    "state": 0,
    "type": "",
    "url": ""
}
 */
export function postaddSavetest(data) {
    return request({
        url: '/v1/app_page',
        method: 'POST',
        data,
    })
}
/**
 * 修改app活动
 */
export function putapppage(data) {
    return request({
        url: '/v1/app_page',
        method: 'put',
        data
    })
}

/**
 * 查询app活动 列表
 * @param {
 *  brand
 *  pageNum
 *  pageSize
 *  state
 * }
 */
export function apppagelist(data) {
    return request({
        url: '/v1/app_page/list',
        method: 'GET',
        params: data,

    })
}


/**
 * 排序
 * @param {
 *  list:[
    {
        "brand": "",
        "createBy": "",
        "createTime": "",
        "data": "",
        "delFlag": "",
        "id": 0,
        "lastUpdateBy": "",
        "lastUpdateTime": "",
        "link": "",
        "sort": "",
        "standby5": "",
        "state": 0,
        "type": "",
        "url": ""
    }
]
 * }
 */
/**
 * 
 * @param {data} 排序 
 */
export function apppagesort(data) {
    console.log('qs.stringify',data)
    // qs.stringify(data)
    return request({
        url: '/v1/app_page/sort',
        method: 'POST',
        data
        // data: qs.parse(data),
        // paramsSerializer: data => {      
        //     return qs.parse(data, { indices: false })
        // }

    })
}

/**
 * 删除
 */
export function apppagedel(data) {
    return request({
        url: `/v1/app_page/${data.ids}`,
        method: 'DELETE'
    })
}


/**
 * 详情 根据id获取详细信息
 */
export function apppagedetails(data) {
    return request({
        url: `/v1/app_page/${data.id}`,
        method: 'GET'
    })
}


/**
 * 修改上架下架
 */
export function apppagestate(data) {
    return request({
        url: `/v1/app_page/${data.id}/${data.state}`,
        method: 'PUT'
    })
}


/** ************************************************** 图片接口 ************************************************** */

/**
 * 
 * @param {data} 删除
 */
export function appageRemoveImg(data) {
    return request({
        url: `/v1/file/delete`,
        method: 'DELETE',
        params: data
    })
}

/** ************************************************** 营销页面接口 ************************************************** */

/**
 * 获取活动页面列表
 * @param {data} data 
 */

export function getActivePage(data) {
    return request({
        url: `/v1/page/list`,
        method: 'GET',
        params:data
    })
}

/**
 * 获取品牌列表
 * @param {*} data 
 */

export function getActiveBrand() {
    return request({
        url: `/v1/page`,
        method: 'GET'
    })
}



/**
 * 新增活动
 * @param {*} data 
 */

export function addActive(data) {
    return request({
        url: `/v1/page`,
        method: 'POST',
        data
    })
}

/**
 * 修改活动页面
 * @param {*} data 
 */

export function updateActive(data) {
    return request({
        url: `/v1/page`,
        method: 'PUT',
        data
    })
}

/**
 * 删除活动
 */
export function delActive(data) {
    return request({
        url: `/v1/page/${data.ids}`,
        method: 'DELETE'
    })
}


/**
 * 根绝id获取页面详情
 */
export function getActiveDetails(data) {
    return request({
        url: `/v1/page/${data.id}`,
        method: 'GET'
    })
}
